import { createFileRoute } from "@tanstack/react-router";
import { TransparencyPage } from "../components/transparency-page";

/**
 * The published year of purchases: `portal.localhost/demo/transparency/2025` locally (US-35.3).
 *
 * <p>Outside `_authed`, like the page behind a QR it is linked from: the reader is a café comparing
 * roasteries, not a customer of this one — yet.
 */
export const Route = createFileRoute("/transparency/$year")({
  component: Transparency,
});

function Transparency() {
  const { year } = Route.useParams();
  return <TransparencyPage year={Number(year)} />;
}
